import type {AditionProfileParams} from '@travel-frontend/ui-components';

import {useEffect, useState} from 'react';

import {mapAditionProfileParams} from '@/modules/common/components/Adition/utils';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';
import {useKeywordData} from '@/modules/common/hooks/useKeywordData';
import {useSearchParams} from '@/modules/common/hooks/useSearchParams';

export const useAditionProfileParams = (): AditionProfileParams | null => {
  const [searchParams] = useSearchParams();
  const currentPage = useCurrentPage();
  const keywordData = useKeywordData(searchParams.destinationId || '');
  const [aditionProfileParams, setAditionProfileParams] =
    useState<AditionProfileParams | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (keywordData.data) {
      setReady(true);
    }
  }, [keywordData.data]);

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      if (!keywordData.data) {
        setReady(true);
      }
    }, 2000);
    return () => {
      window.clearTimeout(timerId);
    };
  }, [keywordData.data]);

  useEffect(() => {
    if (ready && !aditionProfileParams) {
      setAditionProfileParams(
        mapAditionProfileParams({
          searchParams,
          currentPage,
          keyword: keywordData.data,
        })
      );
    }
  }, [
    ready,
    aditionProfileParams,
    searchParams,
    currentPage,
    keywordData.data,
  ]);

  return aditionProfileParams;
};
